export default __webpack_public_path__ + "static/media/car.1daa2835.svg";